import { env } from '@ria-client/env';
import type { BreadcrumbRoot } from './types';

export function BreadcrumbListLinkedData({
  id,
  breadcrumbs,
}: {
  id: string;
  breadcrumbs: BreadcrumbRoot[];
}) {
  const breadcrumbsWithSlugs = breadcrumbs.filter(
    (breadcrumb): breadcrumb is BreadcrumbRoot & { slug: string } => Boolean(breadcrumb.slug),
  );
  const itemListElement = breadcrumbsWithSlugs.map(
    ({ page: { title: name }, slug: href }, index) => {
      const item = new URL(href, env.NEXT_PUBLIC_NW_URL).toString();
      return {
        '@type': 'ListItem',
        position: index + 2,
        name,
        item: index === breadcrumbsWithSlugs.length - 1 ? { '@id': item } : item,
      };
    },
  );
  const __html = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: env.NEXT_PUBLIC_NW_URL },
      ...itemListElement,
    ],
  })
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026');

  return <script id={id} type="application/ld+json" dangerouslySetInnerHTML={{ __html }} />;
}
